import { render, staticRenderFns } from "./ComprasConsumo.vue?vue&type=template&id=2b3345df&"
import script from "./ComprasConsumo.vue?vue&type=script&lang=js&"
export * from "./ComprasConsumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports